export function section08(windowHeight) {
    // let section8 = document.querySelector('.section#section-8');
    // let pinAmount_section8 = section8.outerHeight * 4;
    let pinAmount_section8 = windowHeight * 4

    var storyTL = gsap.timeline({
        scrollTrigger: {
            trigger: ".section#section-8",
            start: "top top",
            end: () => `+=${pinAmount_section8}`,
            scrub: 1,
            pin: ".section#section-8",
        },
    })

    storyTL
        //start of stage 1
        .to(
            ".section#section-8 .stage-indicator-wrapper .stage-indicator#indicator-1",
            {
                opacity: 1,
                ease: "power2.inOut",
            }
        )
        .from(
            ".section#section-8 .motif-wrapper",
            {
                top: "75%",
                opacity: 0,
                ease: "power2.inOut",
            },
            ">-0.25"
        )
        .to(".section#section-8 .stage#stage-1", {
            delay: 0.25,
            opacity: 0,
            ease: "power2.inOut",
        })

        //start of stage 2
        .to(".section#section-8 .section-background", {
            background: "#9f248f",
            ease: "power2.inOut",
        })
        .to(
            ".section#section-8 .stage#stage-2",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-8 .stage-indicator-wrapper .stage-indicator",
            {
                opacity: 0.25,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-8 .stage-indicator-wrapper .stage-indicator#indicator-2",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-8 .motif-wrapper",
            {
                top: "42%",
                ease: "power2.inOut",
            },
            "<"
        )
        .from(
            ".section#section-8 .stage#stage-2 svg#content g#tagline",
            {
                opacity: 0,
                y: "25%",
                ease: "power2.inOut",
            },
            ">-0.25"
        )
        .from(
            ".section#section-8 .stage#stage-2 svg#content g#desc",
            {
                opacity: 0,
                y: "25%",
                ease: "power2.inOut",
            },
            ">-0.25"
        )
        .to(".section#section-8 .stage#stage-2", {
            delay: 0.25,
            opacity: 0,
            ease: "power2.inOut",
        })

        //start of stage 3
        .to(".section#section-8 .section-background", {
            background: "#079873",
            ease: "power2.inOut",
        })
        .to(
            ".section#section-8 .stage#stage-3",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-8 .stage-indicator-wrapper .stage-indicator",
            {
                opacity: 0.25,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-8 .stage-indicator-wrapper .stage-indicator#indicator-3",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-8 .motif-wrapper",
            {
                rotation: -90,
                ease: "power2.inOut",
            },
            "<"
        )
        .from(
            ".section#section-8 .stage#stage-3 svg#content g#tagline",
            {
                opacity: 0,
                y: "25%",
                ease: "power2.inOut",
            },
            ">-0.25"
        )
        .from(
            ".section#section-8 .stage#stage-3 svg#content g#desc",
            {
                opacity: 0,
                y: "25%",
                ease: "power2.inOut",
            },
            ">-0.25"
        )
        .to(".section#section-8 .stage#stage-3", {
            delay: 0.25,
            opacity: 0,
            ease: "power2.inOut",
        })

        //start of stage 4
        .to(".section#section-8 .section-background", {
            background: "#c64097",
            ease: "power2.inOut",
        })
        .to(
            ".section#section-8 .stage#stage-4",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-8 .motif-wrapper",
            {
                rotation: -180,
                ease: "power2.inOut",
            },
            "<"
        )
        .from(
            ".section#section-8 .stage#stage-4 svg#content g#tagline",
            {
                opacity: 0,
                y: "25%",
                ease: "power2.inOut",
            },
            ">-0.25"
        )
        .from(
            ".section#section-8 .stage#stage-4 svg#content g#desc",
            {
                opacity: 0,
                y: "25%",
                ease: "power2.inOut",
            },
            ">-0.25"
        )
        .to(".section#section-8 .stage-indicator-wrapper .stage-indicator", {
            opacity: 0.25,
            ease: "power2.inOut",
        })
        .to(
            ".section#section-8 .stage-indicator-wrapper .stage-indicator#indicator-4",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            "<"
        )
}
